module.exports = __webpack_public_path__ + "static/media/seed2.0f2e6ccc.svg";